import edlFragmentShader from "./edl_f";
import edlVertexShader from "./edl_v";
import opacityFragmentShader from "./opacity_f";
import opacityVertexShader from "./opacity_v";
import pointCloudFragmentShader from "./pointcloud_f";
import pointCloudVertexShader from "./pointcloud_v";
import imageFragmentShader from "./image_f";
import imageVertexShader from './image_v';
import markersFragmentShader from "./markers_f";
import markersVertexShader from './markers_v';
import utilitiesVertexShader from './utilities_v';
import gpuPickerFragmentShader from './gpu_picker_f';

const shaders = {
  pointcloud: {
    vert: pointCloudVertexShader,
    frag: pointCloudFragmentShader
  },
  edl: {
    vert: edlVertexShader,
    frag: edlFragmentShader
  },
  opacity: {
    vert: opacityVertexShader,
    frag: opacityFragmentShader
  },
  image: {
    vert: imageVertexShader,
    frag: imageFragmentShader
  },
  markers: {
    vert: markersVertexShader,
    frag: markersFragmentShader
  },
  utilities: {
    vert: utilitiesVertexShader
  },
  gpu_picker: {
    frag: gpuPickerFragmentShader
  }
};

export default shaders;